import { useParams } from 'react-router-dom';

export const ContactUs = () => {
  return (
    <div className="p-20">
      <h1 className="text-5xl font-bold">Contact Us</h1>
    </div>
  );
};
